import { css } from "@linaria/core";

import { MOBILE_BREAKPOINT_PX } from "../../../../styles/constants";
import { breakpointDownMixin } from "../../../../styles/mixins/breakpoints";
import { outlineMixin } from "../../../../styles/mixins/outline";
import { anchorReset, headingReset } from "../../../../styles/resets";
import { colorProps, figtreeProps } from "../../../../styles/variables";

export const footerHeightProp = "--footer--height";

export const footerCls = css`
  padding: 4.5rem 0;

  background: rgb(var(${colorProps.grey_50}));

  /** pull to bottom relying on flexbox on #app selector */
  margin-top: auto;

  :global(:root) {
    ${footerHeightProp}: 0;
  }
`;

export const boundaryCls = css`
  display: flex;
  align-items: flex-start;

  @media screen and (${breakpointDownMixin(MOBILE_BREAKPOINT_PX)}) {
    flex-direction: column;
  }
`;

export const logoCls = css`
  margin-right: 5rem;
  height: 3.4rem;
  flex-shrink: 0;
`;

export const columnWrapperCls = css`
  margin-left: auto;

  width: 70rem;

  display: flex;
  align-items: flex-start;

  @media screen and (${breakpointDownMixin(MOBILE_BREAKPOINT_PX)}) {
    margin-top: 5.8rem;
    margin-left: 0;

    width: 100%;

    flex-direction: column;
  }
`;

export const columnCls = css`
  margin-right: 3rem;
  flex: 1;

  &:last-child {
    margin-right: 0;
  }

  @media screen and (${breakpointDownMixin(MOBILE_BREAKPOINT_PX)}) {
    margin-right: 0;
    margin-bottom: 3.7rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const columnHeadingCls = css`
  ${headingReset};

  margin-bottom: 1.5rem;

  font-family: var(${figtreeProps.fontFamily});
  font-weight: var(${figtreeProps.medium});
  font-size: 1.8rem;
  line-height: 1.2;
  text-transform: uppercase;

  @media screen and (${breakpointDownMixin(MOBILE_BREAKPOINT_PX)}) {
    margin-bottom: 2rem;
    font-size: 2rem;
  }
`;

export const columnLinkListCls = css`
  margin: 0;
  padding: 0;

  list-style: none;
`;

export const columnLinkCls = css`
  ${anchorReset};
  ${outlineMixin({ targetSelector: "& > span", offset: "0.5rem" })};

  margin-top: 1.2rem;

  display: block;

  font-family: var(${figtreeProps.fontFamily});
  font-weight: var(${figtreeProps.regular});
  font-size: 1.4rem;
  line-height: 1.2;

  &:hover {
    text-decoration: underline;
  }

  @media screen and (${breakpointDownMixin(MOBILE_BREAKPOINT_PX)}) {
    font-size: 1.6rem;
  }
`;
